module.exports = __webpack_public_path__ + "img/foto_1.10dad56d.jpg";